import CustomForm from "../../CustomForm";
import ICustomFormSettings from "../../ICustomFormSettings";
import m, {Vnode, VnodeDOM} from "mithril";
import SuggestionBox from "../../shared/components/SuggestionBox/SuggestionBox";
import {loadJsonFromString} from "../../shared/helpers";
import {LabelItem} from "../../../model/items/labelItem";
import ItemsSuggestionSource, {Item} from "../../shared/components/SuggestionBox/source/ItemsSuggestionSource";
import {TextboxItem} from "../../../model/items/textbox";
import LabelCell from "../../shared/components/FormCell/LabelCell";

type TSuggestionTree = {[key: string]: TSuggestionTree|string[]|null};
type TSuggestionTreeSetting = {maxResultsCount?: number};

export default class TextTree extends CustomForm {

    private readonly labelCells: LabelCell[] = [];
    private suggestionBoxes: SuggestionBox[] = [];
    private tree?: TSuggestionTree;
    private treeSetting: TSuggestionTreeSetting = {};
    private error?: string;

    private readonly outputTexts: TextboxItem[] = []

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const layout = settings.form.grid.layout;

        layout.forEach((row) => {
            this.labelCells.push(new LabelCell(<LabelItem>row[0].cellItems[0]));
            this.outputTexts.push(<TextboxItem>row[1].cellItems[0]);
        });

        loadJsonFromString(this.settings.form.aux2 || '{}', this.settings.form.questionary,d => this.onLoadJsonSettings(d))
        loadJsonFromString(this.settings.form.aux1, this.settings.form.questionary,d => this.onLoadJsonDefinition(d), e => this.onErrorJsonDefinition(e))
    }

    checkRequirements(): boolean {
        if (!this.settings.form.aux1) {
            console.warn(`customForm-Text-tree: Missing JSON tree definition in aux1 field.`);
            return false;
        }
        if (this.outputTexts.length === 0) {
            console.warn(`customForm-Text-tree: Missing textbox outputs.`);
            return false;
        }

        return true;
    }

    private onErrorJsonDefinition(error: any): void {
        this.error = "Unable to load definitions.";
        console.error(error);
        m.redraw();
    }

    private onLoadJsonSettings(treeSetting: TSuggestionTree): void {
        this.treeSetting = treeSetting;
    }

    private onLoadJsonDefinition(tree: TSuggestionTree): void {
        this.tree = tree;
        this.updateSuggestionBoxes();
        m.redraw();
    }

    private updateSuggestionBoxes(): void {
        this.suggestionBoxes = [];

        let tree: TSuggestionTree|string[]|undefined = this.tree;
        let i = 0;
        while (tree && i < this.outputTexts.length) {
            const textBox = this.outputTexts[i];
            const selectedItemId = textBox.getVariable();
            const items = this.createItems(tree);
            const box = new SuggestionBox(
                items,
                item => {
                    textBox.set(item.id);
                    this.updateSuggestionBoxes();
                    m.redraw();
                },
                items.filter(item => item.id === selectedItemId)[0] || null
            );

            (<ItemsSuggestionSource>box.suggestionSource).setMaxResultsCount(this.treeSetting?.maxResultsCount || 100);

            this.suggestionBoxes.push(box);
            if (selectedItemId) {
                tree = tree && <TSuggestionTree|undefined>tree[selectedItemId];
                i++;
            } else {
                tree = undefined;
            }
        }
        for (let j=i; j<this.outputTexts.length; j++) {
            this.outputTexts[j].reset();
        }
    }

    private createItems(tree: TSuggestionTree|string[]|null): Item[] {
        if (!tree) {
            return [];
        }
        
        if (Array.isArray(tree)) {
            return tree.map(l => {return {id: l, item: l}});        
        }
        
        const items = [];
        for (const key in tree) {
            items.push({id: key, item: key});
        }
        return items;
    }

    public view(): Vnode {
        const boxes: (LabelCell|SuggestionBox)[] = [];
        this.suggestionBoxes.forEach((sb, i) => {
           boxes.push(this.labelCells[i]);
           boxes.push(sb);
        });

        return this.viewLayout(this.tree ? boxes.map(b => m(b)) : this.viewLoading());
    }

    private viewLoading(): Vnode {
        return m('.loading', {}, [
            m('.icon.icon-cached.spinning', {title: "Loading"}),
            this.error ? m('.', {}, this.error) : null,
        ]);
    }

    oncreate(vnode: VnodeDOM): void {
        super.oncreate(vnode);
        $('.nms-survey.isCustomForm').css('overflow', 'visible');
    }

    onremove(): void {
        $('.nms-survey.isCustomForm').css('overflow', '');
    }


}